import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class SellerPermissaoEspecialService {
  private baseUrl: string;

  constructor(
    private http: HttpClient,
    @Inject("BASE_URL") baseUrl: string,
    private toastr: ToastrService
  ) {
    this.baseUrl = baseUrl;
  }

  public getByVendedor(sellerId: number): Observable<string[]> {
    return this.http.get<string[]>(this.baseUrl + `api/SellerPermissaoEspecial/${sellerId}`).pipe(
      catchError(() => {
        this.toastr.error("", "Erro ao carregar permissões...");
        return of([]);
      })
    );
  }

  public salvar(sellerId: number, bloqueadas: string[]): Observable<boolean> {
    const guidclientenapis = localStorage.getItem('guidclientenapis') || '';
    const body = { bloqueadas, guidclientenapis };
    return this.http.put<boolean>(this.baseUrl + `api/SellerPermissaoEspecial/${sellerId}`, body).pipe(
      catchError(() => {
        this.toastr.error("", "Erro ao salvar permissões...");
        return of(false);
      })
    );
  }
}
